import { useState } from 'react'
import CustomerService from './CustomerService'
import CustomerServiceDetailsModal from 'pages/Modals/CustomerServiceDetailsModal'
import ChangeCustomerServicesModal from 'pages/Modals/ChangeCustomerServicesModal'

import {
  Container,
  SubTitle,
  InfoText,
  LabelRow
} from './styles'

export default function CustomerServiceList ({
  customer,
  customerServices = [],
  emptyStateText = 'Este cliente ainda não possui pacotes',
  onUpdate: handleUpdate = () => {}
}) {
  const [serviceData, setServiceData] = useState (null)
  const [serviceEditData, setServiceEditData] = useState (null)
  const [showServiceDetailsModal, setShowServiceDetailsModal] = useState (false)
  const [showChangeServicesModal, setShowChangeServicesModal] = useState (false)

  const handleClick = service => {
    setServiceData (service)
    toggleServiceDetailsModal ()
  }

  const handleChangeService = service => {
    setServiceEditData (service)
    toggleChangeServicesModal ()
  }

  const toggleServiceDetailsModal = () => setShowServiceDetailsModal (!showServiceDetailsModal)
  const toggleChangeServicesModal = () => setShowChangeServicesModal (!showChangeServicesModal)

  if (customerServices.length === 0) return (
    <Container>
      <InfoText>{emptyStateText}</InfoText>
    </Container>
  )

  return (
    <Container>
      <LabelRow>
        <SubTitle>Serviço</SubTitle>
        <SubTitle>Pacote / cartão</SubTitle>
        <SubTitle>Comanda</SubTitle>
        <SubTitle>Qtd.</SubTitle>
        <SubTitle>Qtd. utilizada</SubTitle>
        <SubTitle>Qtd. disponível</SubTitle>
        <SubTitle>Validade</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {customerServices.map ((service, index) => (
        <CustomerService
          key={index}
          data={service}
          onClick={handleClick}
          onEdit={handleChangeService}
        />
      ))}
      {!!serviceData && (
        <CustomerServiceDetailsModal
          visible={showServiceDetailsModal}
          customer={customer}
          service={serviceData}
          onClose={toggleServiceDetailsModal}
        />
      )}
      {!!serviceEditData && (
        <ChangeCustomerServicesModal
          visible={showChangeServicesModal}
          customer={customer}
          service={serviceEditData}
          onConfirm={handleUpdate}
          onClose={toggleChangeServicesModal}
        />
      )}
    </Container>
  )
}
